var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#323657",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4 21v-7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#323657",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4 10V3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#323657",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 21v-9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#323657",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 8V3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#323657",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M20 21v-5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#323657",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M20 12V3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#323657",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1 14h6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#323657",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9 8h6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#323657",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17 16h6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterMobile);
export default __webpack_public_path__ + "static/media/filter-mobile.25089701f3faf1cd44db7332fe618222.svg";
export { ForwardRef as ReactComponent };